module.exports = __webpack_public_path__ + "assets/img/温广平.43a1e408.png";